import axios from 'axios';
import {
  EVENTS_LOAD_PAGE_CONTENT_BEGIN,
  EVENTS_LOAD_PAGE_CONTENT_SUCCESS,
  EVENTS_LOAD_PAGE_CONTENT_FAILURE,
  EVENTS_LOAD_PAGE_CONTENT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadPageContent(args = {}) {
  return dispatch => {
    dispatch({
      type: EVENTS_LOAD_PAGE_CONTENT_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`${process.env.REACT_APP_BUILDER_ENGINE}${args.uri}`, header);
      doRequest.then(
        res => {
          dispatch({
            type: EVENTS_LOAD_PAGE_CONTENT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: EVENTS_LOAD_PAGE_CONTENT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPageContentError() {
  return {
    type: EVENTS_LOAD_PAGE_CONTENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_LOAD_PAGE_CONTENT_BEGIN:
      return {
        ...state,
        loadPageContentPending: true,
        loadPageContentError: null,
      };

    case EVENTS_LOAD_PAGE_CONTENT_SUCCESS:
      return {
        ...state,
        loadPageContentPending: false,
        loadPageContentError: null,
        pageContent: action.data,
      };

    case EVENTS_LOAD_PAGE_CONTENT_FAILURE:
      return {
        ...state,
        loadPageContentPending: false,
        loadPageContentError: action.data.error,
      };

    case EVENTS_LOAD_PAGE_CONTENT_DISMISS_ERROR:
      return {
        ...state,
        loadPageContentError: null,
      };

    default:
      return state;
  }
}
